<template>
    <Layout>
        <Header style="height: 60px;line-height:60px;background:white;border-bottom: 1px solid #dcdee2;padding-right: 5px;">
            <Row type="flex" justify="end" class="code-row-bg">
                <Col span="3" class="clopageindex">第{{_index}}屏</Col>
                <Col span="21" style="text-align: right;">
                <ButtonGroup size="default">
                    <Button icon="md-cloud-upload" @click="PopFolderTreeV2" :style="{display:uploadshow?'block':'none'}">上传云端</Button>
                    <Button @click="downloadfile" icon="md-cloud-download" :style="{display:downloadshow?'block':'none'}">普通下载</Button>
                    <Button type="success" @click="downloadYunFiles" icon="md-cloud-download" :style="{display:downloadshow?'block':'none'}">云擎下载</Button>
                    <Button class="closebtn"  v-on:click="removeSlider" type="text" icon="md-close" style="box-shadow: none;font-size: 20px;margin-left: 10px;border-radius: 5px;"></Button>
                </ButtonGroup>
                 
                </Col>
            </Row>
            <Modal v-model="modalPages" width="450" :mask-closable="false" :z-index="1501">
                <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                    <Icon type="ios-information-circle"></Icon>
                    <span>请选择您要下载的文档</span>
                </p>
                <div style="text-align:center;height: 400px;overflow: auto;">
                    <!--  <DocManage ref="DocMng"></DocManage> -->
                    <!-- <RelatedFile ref="relatedFileRead"></RelatedFile> -->
                    <RelatedFile ref="downLoadfiles" @bindcomplete="dataBindOk"></RelatedFile>
                </div>
                <div slot="footer">
                    <Button type="text" size="large" @click="downLoadCancel">取消</Button>
                    <Button type="primary" size="large" @click="down">确定</Button>
                </div>
            </Modal>
            <FolderTree ref="folderTreeSelector" @onFolderSelected="onfolderSelected2" @onSelectCannel="onFolderSelectCannel2" />

        </Header>
        <!--     <Content :style="{height:'84.0vh',overflow:'scroll'}"> -->
        <Content :class="resolution<1920?'screenMin':'screenDefault'">
            <DocmentPlay ref="docmentplay" :docfileid="message" :order="orderid" :trow="gorow" @remove="removeSlider" @loadComplete="loaded" @onOpen="open" @onDocFinished="docFinished"></DocmentPlay>
            <Spin size="large" fix v-if="spinShow"></Spin>
        </Content>
        <!-- <Footer :style="{background:'white',
    color:'black',
    paddingTop:'10px'}">第{{page_index}}屏</Footer> -->
    </Layout>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import drawerLayer from './drawerpage.vue'
import DocmentPlay from './showdocument.vue'
import RelatedFile from '../../smart_cloud/workbook_related_table.vue'
import FolderTree from '../../smart_cloud/showFolderTreeV2.vue'
import { uuid } from 'vue-uuid'
import { mapGetters } from 'vuex'
import eventBus from "../../../components/common/event_bus.js"
import constJson from '../../../api/common/constjson.js'
import store from '../../../store/'
let constJ = new constJson()
// import http from '../../../api/http/http.js'
export default {
    props: {
        pageindex: Number,
        message: String,
        orderid: Number,
        gorow: Object,
        docid: Number,
    },
    inject: ['Back'],
    name: "DocmentPage",
    data() {
        return {
            text: this.message,
            page_index: this.pageindex,
            html: null,
            pagename: "../../../../static/std.htm",
            spinShow: true,
            resolution: 0,
            uploadshow: true,
            downloadshow: true,
            modalPages: false,
            _folderId:'',
            _folderValue:'',
        }
    },
    computed: {
        ...mapGetters(['getUserId', 'sta']),
        _index:function(){
            return this.$Tools.numberToChineseString(String(this.page_index))
        }
    },
    created: function() {
        //let screenWidth=screen.width+","+screen.height
        this.resolution = screen.width
        //console.log(this.resolution)
    },
    methods: {
        PopFolderTreeV2(type=0) {
            if (!this.checkUserLogin()) {
                console.log('uploadfile->checkUserLogin')
                eventBus.$emit("user-login", "true","0") //临时登录
                return
            }

            var treeData = []
            var folderData = store.state.user.myfolders
            if (!folderData) {
                this.$Message.warning('沒有云端文件夹，请前往在线商城购买')
                return false
            }
            console.log('PopFolderTreeV2==>')
            console.log(folderData)
            this.$refs.folderTreeSelector.bindFolderTree(folderData,type)
            return true
        },
        onFolderSelectCannel2() {
            console.log('onFolderSelectCannel...')
        },
        onfolderSelected2(folderid, type,node) {
            console.log('onfolderSelected...')
            this._folderId = folderid
            this._folderValue=node.label
            //上传
            this.uploadfileV2()

        },

        //main2-setIndex
        setIndex(index) {
            this.page_index = index
        },
        turnBack() {
            this.Back();
        },
        //子组件emit是否打开的jd文件
        loaded(value) {
            this.spinShow = false;
            if(value && value.jd){
                this.uploadshow=false
            }

        },
        searchList() {
            this.$refs.searchResult.showlayer(["preferential", "filename"]);
        },
        handleLoadDoc() {

        },
        open(fileid, orderid, filename) {
            this.$emit('onOpen', fileid, orderid, filename)
        },
        docFinished(item, orderid) {
            this.$emit('onDocFinished', item, orderid)
        },
        getScreen() {
            // let screenWidth=document.body.clientWidth+","+document.body.clientHeight
            let screenWidth = screen.width + "," + screen.height
            console.log(screenWidth)

        },
        showMessage(msg) {
            //console.log(msg)
            if (msg === undefined || msg === "") {
                this.$Message.error("文件下载出错...")
            } else {
                this.$Message.error(msg)
            }

        },
        downloadYunFiles() {
            //检查登录
            // if (!this.checkUserLogin()) {
            //     console.log('downloadYunFiles->checkUserLogin')
            //     eventBus.$emit("user-login", "true") //临时登录
            //     return
            // }

            //检查云擎下载权限
            //let code = "000010"
            // let accountstatus = this.sta.accountstatus
            // if (!this.checkPermission(code)) {
            //     if (accountstatus === 0) {
            //         this.$Message.warning('要体验云擎下载功能，请您先注册')
            //         return
            //     } else if (accountstatus === 100) {
            //         eventBus.$emit('user-nopermission-board', '要获得云擎下载权限,请前去在线商城购买账号等级',1)
            //         return
            //     } else if (accountstatus === 200) {
            //         eventBus.$emit('user-nopermission-board', '要获得云擎下载权限,请前去在线商城购买VIP升级权限',2)
            //         return
            //     }
            // }

            //检查接口权限
            let code = this.$Tools.getPermission().CODE_FUNC_DOWNLOAD
            let name = "云擎下载"
            let po = {
                funccode: code,
                funcname: name,
            }
            this.checkUserPermission(po,3)
        },
        //检查接口访问权限，验证成功则访问，验证失败则提示
        //fType,=1上传云端,=2普通下载,=3云擎下载
        checkUserPermission(po, fType) {
            constJ.reqCheckUserPromission(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (!res.result.protect) {
                            if (fType === 1) {

                            } else if (fType === 2) {
                                //访问普通下载
                                if (this.orderid === 1 || this.orderid===3) {
                                    var strdocid = this.text
                                    constJ.reqDownLoadOneFile(strdocid, undefined, this.showMessage)
                                } else if (this.orderid === 2) {
                                    this.showDownLoadFiles(this.text)
                                }
                            } else if (fType === 3) {
                                //访问云擎下载
                                if (this.orderid === 1  || this.orderid===3) {
                                    var strdocid = this.text
                                    constJ.reqDownLoadFile(strdocid, undefined, this.showMessage)
                                } else if (this.orderid === 2) {
                                    //this.showDownLoadFiles(this.text)
                                }
                            }
                        } else {
                            if (res.result.warninglevel === 1) {
                                //登录
                                eventBus.$emit("user-login", "true","0") //临时登录
                                return
                            } else if (res.result.warninglevel === 2) {
                                //去商城账号等级
                                eventBus.$emit('user-nopermission-board', res.result.warningtext, 1)
                                return
                            } else if (res.result.warninglevel === 3) {
                                //去商城升级vip
                                eventBus.$emit('user-nopermission-board', res.result.warningtext, 2)
                                return
                            } else {
                                console.log('待处理的警告等级===>' + res.result.warninglevel)
                                return
                            }
                        }

                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {
                // this.$Message.error(err.rtndesc);
                // return
            })
        },
        //权限控制
        checkPermission(code) {
            //"000014" // 普通下载
            let rsp = false
            let checkcode = code
            let permission = this.sta.permission
            if (permission && permission.length > 0) {
                let index = permission.findIndex(p => p.f === checkcode)
                console.log('checkcode.index:' + index)
                if (index >= 0) {
                    rsp = true
                }
            }
            return rsp
        },
        checkUserLogin() {
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        //普通下载
        downloadfile() {
            console.log("download.orderid:" + this.orderid)
            console.log("fileid:" + this.message)
            console.log("text:" + this.text)

             //检查接口权限
            let code = this.$Tools.getPermission().CODE_FUNC_ONEDOWNLOAD
            let name = "普通下载"
            let po = {
                funccode: code,
                funcname: name,
            }
            this.checkUserPermission(po,2)
        },
        //普通下载(停用)
        // downloadfile1() {
        //     console.log("download.orderid:" + this.orderid)
        //     console.log("fileid:" + this.message)
        //     console.log("text:" + this.text)

        //     if (!this.checkUserLogin()) {
        //         console.log('downloadfile->checkUserLogin')
        //         eventBus.$emit("user-login", "true") //临时登录
        //         return
        //     }
        //     //检查一普通下载权限
        //     //let code = "000014"
        //     let code = this.$Tools.getPermission().CODE_FUNC_ONEDOWNLOAD
        //     console.log('检查一普通下载权限====>' + code)
        //     let accountstatus = this.sta.accountstatus
        //     if (!this.checkPermission(code)) {
        //         if (accountstatus === 0) {
        //             this.$Message.warning('要体验普通下载功能，请您先注册')
        //             return
        //         } else if (accountstatus === 100) {
        //             eventBus.$emit('user-nopermission-board', '要获得普通下载权限,请前去在线商城购买账号等级')
        //             return
        //         }
        //     }

        //     if (this.orderid === 1) {
        //         var strdocid = this.text
        //         constJ.reqDownLoadOneFile(strdocid, undefined, this.showMessage)
        //     } else if (this.orderid === 2) {
        //         this.showDownLoadFiles(this.text)
        //     }
        // },

        // download(url) {

        //   var xhh = new XMLHttpRequest();

        //   let page_url = url;
        //   xhh.open("get", page_url);

        //   xhh.responseType = 'blob';
        //   xhh.onreadystatechange = function() {
        //     if (xhh.readyState === 4 && xhh.status === 200) {
        //       console.log(xhh)
        //       var name = xhh.getResponseHeader("Content-Language");
        //       var filename = decodeURIComponent(name); //name.substring(20, name.length);
        //       var blob = new Blob([xhh.response], { type: 'application/octet-stream' });
        //       var csvUrl = URL.createObjectURL(blob);
        //       var link = document.createElement('a');
        //       link.href = csvUrl;
        //       link.download = filename;
        //       link.click();

        //     }
        //   };
        //   xhh.send();
        // },
        showDownLoadFiles(bookid) {
            this.modalPages = true
            this.bindDownLoadFiles(bookid)

        },
        bindDownLoadFiles(bookid) {
            console.log("bookid:" + bookid)
            constJ.getWorkBookDownLoadList(bookid).then(res => {
                //console.log(res)
                var files = []
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //console.log(res)
                        //var file = { fileid: fileid, filename: fname, index: 0, key: uuid.v1(), }
                        let items = res.tbls[0].items
                        if (items !== undefined && items.length > 0) {
                            for (let i = 0; i < items.length; i++) {
                                var file = {
                                    fileid: items[i].docid,
                                    filename: items[i].h1,
                                    bookid: items[i].bookid,
                                    index: 0,
                                    key: uuid.v1(),
                                }
                                files.push(file)
                            }
                            this.$refs.downLoadfiles.bindDownLoadFiles(files)
                            //this.$refs.downLoadfiles.handleSelectAll(true)
                        }
                    } else {

                    }
                } else {

                }

            })
        },
        dataBindOk() {

        },

        down() {
            //console.log("down...")
            console.log(this.$refs.downLoadfiles.getSelected())
            var items = this.$refs.downLoadfiles.getSelected()
            var docs = []
            var bid = 0;
            if (items !== undefined && items.length > 0) {
                for (let i = 0; i < items.length; i++) {
                    var docid = parseInt(items[i].fileid)
                    bid = items[i].bookid
                    docs.push(docid)
                }
                var book = {
                    bookid: bid,
                    docid: docs
                }
                // console.log("req book...")
                // console.log(book)
                constJ.reqPostDownLoadFile(book, this.showMessage)

            }
            this.modalPages = false
            this.$Message.success('下载中,请稍后...');
        },
        downLoadCancel() {
            this.modalPages = false
        },
        showMessage(msg) {
            this.$Message.error(msg)
        },
        checkUserLogin() {
            //console.log(store.state.user.userId)
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },

        //打开的文件，上传至云端（原来固定文件夹）
        uploadfile() {
            console.log("fileid:" + this.message)
            console.log("text:" + this.text)
            console.log("docid:" + this.docid)
            //console.log(store.state.user.folder.data.tabrows)
            var folderid = ""
            if (this.checkUserLogin()) {
                var arr = store.state.user.folder.data.tabrows
                if (arr !== undefined) {
                    const findelement = arr.find(element => element.foldername === "文件夹一")
                    folderid = findelement.folderid
                }

            } else {
                // this.$Message.warning("请您先登录再使用 [上传云端] 功能.")
                console.log('uploadfile->checkUserLogin')
                eventBus.$emit("user-login", "true","0") //临时登录
                return
            }

            //console.log(findelement)
            // var obj = {
            //   docid: parseInt(this.text)
            // }
            let docids = []
            docids.push(parseInt(this.docid))
            constJ.upLoadFileToCloud(docids, folderid).then(res => {
                // console.log()
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //console.log(this.message + "上传成功...")
                        this.$Message.success({
                            content: '文件已成功上传至智慧云端-上传文件库-文件夹一',
                            duration: 3
                        })
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {
                // this.$Message.error(err.rtndesc);
                // return
            })
        },
        //自定义文件夹（在用）
        uploadfileV2() {
            console.log("fileid:" + this.message)
            console.log("text:" + this.text)
            console.log("docid:" + this.docid)
            let docids = []
            docids.push(parseInt(this.docid))
            constJ.upLoadFileToCloud(docids, this._folderId).then(res => {
                // console.log()
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //console.log(this.message + "上传成功...")
                        this.$Message.success({
                            content: '已成功上传至智慧云端：'+this._folderValue,
                            duration: 3
                        })
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {
                // this.$Message.error(err.rtndesc);
                // return
            })
        },

        //文件上传用docid
        // uploadfile1() {
        //     console.log("fileid:" + this.message)
        //     console.log("text:" + this.text)
        //     console.log("docid:" + this.docid)
        //     //console.log(store.state.user.folder.data.tabrows)
        //     var folderid = ""
        //     if (this.checkUserLogin()) {
        //         var arr = store.state.user.folder.data.tabrows
        //         if (arr !== undefined) {
        //             const findelement = arr.find(element => element.foldername === "文件夹一")
        //             folderid = findelement.folderid
        //         }

        //     } else {
        //         // this.$Message.warning("请您先登录再使用 [上传云端] 功能.")
        //         console.log('uploadfile->checkUserLogin')
        //         eventBus.$emit("user-login", "true") //临时登录
        //         return
        //     }

        //     //console.log(findelement)
        //     // var obj = {
        //     //   docid: parseInt(this.text)
        //     // }
        //     let docids = []
        //     docids.push(parseInt(this.docid))
        //     constJ.upLoadFileToCloud(docids, folderid).then(res => {
        //         // console.log()
        //         if (res.rtncode === 1) {
        //             if (res.rltcode === 1) {
        //                 //console.log(this.message + "上传成功...")
        //                 this.$Message.success({
        //                     content: '文件已成功上传至智慧云端-上传文件库-文件夹一',
        //                     duration: 3
        //                 })
        //             } else {
        //                 this.$Message.error(res.rltdesc);
        //                 return
        //             }
        //         } else {
        //             this.$Message.error(res.rtndesc);
        //             return
        //         }
        //     }).catch(function(err) {
        //         // this.$Message.error(err.rtndesc);
        //         // return
        //     })
        // },
        removeSlider() {
            console.log(this.$refs.docmentplay.isPlay)
            if(this.$refs.docmentplay.isPlay){
                console.log('正在移除放音===>')
                // eventBus.$emit('tts-stop',this.$refs.docmentplay.docname)
                eventBus.$emit('audiotts-stop',this.$refs.docmentplay.docname)
                
            }
            this.$emit('remove')
        }
    },
    watch: {
        text: function(n, o) {
            //this.text=o;
        }
    },
    mounted() {
        //orderid=1 普通文档,orderid=2 工作薄文档,orderid=3 云端文件
        console.log('mounted===>')
        console.log(this.gorow)
        if (this.orderid === 2) {
            this.uploadshow = false
            //this.downloadshow = false
        } else if (this.orderid === 3) {
            this.uploadshow = false
        }else if(this.gorow&&this.gorow.jd){//官方解答不能上传到云端
            this.uploadshow=false
        }
        else if(this.gorow&&this.gorow.wsw){//涉税判例不能上传到云端
            this.uploadshow=false
        }
        else if(this.gorow&&this.gorow.case){//税务案例不能上传到云端
            this.uploadshow=false
        }
        
        // axios
        //   .get('../../../../static/std.htm')
        //   .then(response => (this.html = response.data))

    },
    components: {
        'SearchList': drawerLayer,
        'DocmentPlay': DocmentPlay,
        'RelatedFile': RelatedFile,
        FolderTree,
    }
}
</script>
<style scoped>
/*.footer {
  background: #515a6e;
  color: white;
}

.content {
  padding: 24px;
  minHeight: 280px;
  background: #fff;
}

.content ivu-layout-content {
  padding: 0px !important;
}*/
/*低分率文件界面默认高度*/
.screenMin {
    height: 88.3vh;
    overflow-y: scroll;
    background: white;
    padding-bottom: 150px;

}
/*文件界面默认高度*/
.screenDefault {
    height: 92vh;
    overflow-y: scroll;
    background: white;
}
.closebtn:hover{
    background: #dcdee2;
    color:black;
    border-radius: 5px;
}
.clopageindex{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #000000;
}
</style>